import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToggleReturnsChart from 'src/javascripts/components/charts/actions/ToggleReturnsChart';
import ReturnsChart from 'src/javascripts/components/charts/ReturnsChart';
import ReturnsDollarsChart from 'src/javascripts/components/charts/ReturnsDollarsChart';

export default class ResearchFundsShow {

  constructor() {}

  render() {

    // Initialize a new chart instance for each chart on the page
    if (($('#returns_chart').attr('data-return-option') === 'percentage') && (typeof $('#returns_chart').data('c3-chart') === 'undefined')) {

      // Set chartId and chart object
      // Get data, render chart, set up chart, and create connected table, if exists
      let chart = new ReturnsChart($('#returns_chart'));
      $.when(chart.getData())
       .then( data => chart.render(data))
       .then( chartObj => chart.setUp(chartObj));

    } else if (($('#returns_chart').attr('data-return-option') === 'dollar') && (typeof $('#returns_chart').data('c3-chart') === 'undefined')) {

      // Set chartId and chart object
      // Get data, render chart, set up chart, and create connected table, if exists
      let chart = new ReturnsDollarsChart($('#returns_chart'));
      $.when(chart.getData())
       .then( data => chart.render(data))
       .then( chartObj => chart.setUp(chartObj));

    }

    // Toggle returns chart between hypothetical growth and percentage returns
    ToggleReturnsChart();

  }

}